import { NICmsContentComponent } from '@icms/core/content';

export namespace NCmsComponentCategoryQuickLinks {
    export const ID = 'cms-category-quick-links';

    export interface IData extends NICmsContentComponent.IData {
        quickLinks?: IQuickLink[];
        // A/B testing field (abIfExp) is automatically injected by the A/B testing module
        // No need to explicitly define it here
    }

    export interface IQuickLink {
        label: string;
        url: string;
    }
}
